import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';
import { SheetHeader } from '../../components/counter-flow/sheetParts';

interface WizardSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  /** aria-label for the dialog when the title alone is ambiguous. */
  label?: string;
  children: React.ReactNode;
}

/** Board BookVisit pop-up: bottom sheet on phones (28px top radius), centred card from md. */
const WizardSheet: React.FC<WizardSheetProps> = ({ isOpen, onClose, title, label, children }) => (
  <Modal isOpen={isOpen} onClose={onClose} motionPreset="slideInBottom">
    <ModalOverlay bg="rgba(14,14,14,0.55)" />
    <ModalContent
      aria-label={label ?? title}
      fontFamily="display"
      color="#0E0E0E"
      borderTopRadius="28px"
      borderBottomRadius={{ base: 0, md: '28px' }}
      mx={{ base: 0, md: 4 }}
      mt="auto"
      mb={{ base: 0, md: 'auto' }}
      maxW={{ base: '100%', md: '480px' }}
      boxShadow="none"
    >
      <ModalBody p="10px 20px 28px 20px" pb={{ base: 'calc(28px + env(safe-area-inset-bottom))', md: '28px' }}>
        <SheetHeader title={title} onClose={onClose} />
        {children}
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default WizardSheet;
